import mobilePagePans from './mobilePagePans.js';

const mobilePagePan = {
  init(definitions = mobilePagePans) {
    const container = document.querySelector('.pages-container');
    if (!container) return;
    const pages = Array.from(container.querySelectorAll('.pages-inner > .page'));
    const entries = [];
    for (const definition of definitions) {
      const page = pages.find(element => element.dataset.id === String(definition.page));
      const image = page?.querySelector(':scope > .page-image');
      if (!image) continue;
      const stage = document.createElement('div');
      stage.className = 'mobile-page-pan-stage';
      page.classList.add('mobile-page-pan');
      image.before(stage);
      const canvas = document.createElement('div');
      canvas.className = 'mobile-page-pan-canvas';
      stage.append(canvas);
      canvas.append(image);
      entries.push({ page, image, canvas, travel: 0 });
    }
    if (!entries.length) return;
    const desktop = matchMedia('(min-width: 768px)');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => {
      for (const { page, canvas, travel } of entries) {
        if (desktop.matches || reducedMotion.matches) {
          canvas.style.removeProperty('transform');
          continue;
        }
        const consumed = container.getBoundingClientRect().top - page.getBoundingClientRect().top;
        const offset = Math.max(0, Math.min(travel, consumed));
        canvas.style.transform = `translateX(${-offset}px)`;
      }
    };
    const layout = () => {
      const enabled = !desktop.matches && !reducedMotion.matches;
      for (const entry of entries) {
        const { page, image } = entry;
        page.classList.toggle('mobile-page-pan--enabled', enabled);
        if (enabled) {
          const height = container.clientHeight;
          const ratio = (image.naturalWidth || Number(image.getAttribute('width'))) /
            (image.naturalHeight || Number(image.getAttribute('height')));
          const width = Math.max(container.clientWidth, height * ratio);
          entry.travel = width - container.clientWidth;
          page.style.height = `${height + entry.travel}px`;
          page.style.setProperty('--mobile-pan-height', `${height}px`);
          page.style.setProperty('--mobile-pan-width', `${width}px`);
          page.style.setProperty('--mobile-pan-scale', String(height / 900));
        } else {
          entry.travel = 0;
          page.style.removeProperty('height');
        }
      }
      update();
    };
    container.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', layout);
    desktop.addEventListener('change', layout);
    reducedMotion.addEventListener('change', layout);
    for (const { image } of entries) image.addEventListener('load', layout);
    new ResizeObserver(layout).observe(container);
    layout();
  },
};

export default mobilePagePan;